webpackJsonp([233451654573184],{

/***/ 25:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(25)))

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(96);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/featuresSlider1.1af3eb4b.jpg";

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/featuresSlider2.745b07fc.jpg";

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/featuresSlider3.90e5e3df.jpg";

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/featuresSlider4.09713142.jpg";

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/featuresSlider5.34a8cc31.jpg";

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/featuresSlider6.0e5417e9.jpg";

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/history.b475f81c.jpg";

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kopp.16ac34b5.jpg";

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _thehouse = __webpack_require__(106);
	
	var _thehouse2 = _interopRequireDefault(_thehouse);
	
	var _FeaturesBlockModule = __webpack_require__(299);
	
	var _FeaturesBlockModule2 = _interopRequireDefault(_FeaturesBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeaturesBlock = function FeaturesBlock(props) {
	  var language = props.language;
	
	
	  return _react2.default.createElement(
	    'section',
	    { className: _FeaturesBlockModule2.default.featuresBlock },
	    _react2.default.createElement(
	      'div',
	      { className: [_FeaturesBlockModule2.default.category, _FeaturesBlockModule2.default.general].join(' ') },
	      _react2.default.createElement(
	        'h2',
	        { className: 't-heading-xs' },
	        _thehouse2.default[language].featuresItems1Title
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _thehouse2.default[language].featuresItems1.map(function (item) {
	          return _react2.default.createElement(
	            'li',
	            { key: item },
	            item
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: [_FeaturesBlockModule2.default.category, _FeaturesBlockModule2.default.recreation].join(' ') },
	      _react2.default.createElement(
	        'h2',
	        { className: 't-heading-xs' },
	        _thehouse2.default[language].featuresItems2Title
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _thehouse2.default[language].featuresItems2.map(function (item) {
	          return _react2.default.createElement(
	            'li',
	            { key: item },
	            item
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: [_FeaturesBlockModule2.default.category, _FeaturesBlockModule2.default.domestic].join(' ') },
	      _react2.default.createElement(
	        'h2',
	        { className: 't-heading-xs' },
	        _thehouse2.default[language].featuresItems3Title
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _thehouse2.default[language].featuresItems3.map(function (item) {
	          return _react2.default.createElement(
	            'li',
	            { key: item },
	            item
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: [_FeaturesBlockModule2.default.category, _FeaturesBlockModule2.default.facilities].join(' ') },
	      _react2.default.createElement(
	        'h2',
	        { className: 't-heading-xs' },
	        _thehouse2.default[language].featuresItems4Title
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _thehouse2.default[language].featuresItems4.map(function (item) {
	          return _react2.default.createElement(
	            'li',
	            { key: item },
	            item
	          );
	        })
	      )
	    )
	  );
	};
	
	FeaturesBlock.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	FeaturesBlock.defaultProps = {};
	
	exports.default = FeaturesBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-FeaturesBlock----FeaturesBlock-module---loader---2KQjL","before":"src-components-FeaturesBlock----FeaturesBlock-module---before---39iBo","after":"src-components-FeaturesBlock----FeaturesBlock-module---after---2LteF","t-body":"src-components-FeaturesBlock----FeaturesBlock-module---t-body---3_ciw","t-small":"src-components-FeaturesBlock----FeaturesBlock-module---t-small---BIWsZ","t-heading-xs":"src-components-FeaturesBlock----FeaturesBlock-module---t-heading-xs---D1zwU","t-heading-s":"src-components-FeaturesBlock----FeaturesBlock-module---t-heading-s---2W8ex","t-heading-m":"src-components-FeaturesBlock----FeaturesBlock-module---t-heading-m---IpvOe","t-heading-l":"src-components-FeaturesBlock----FeaturesBlock-module---t-heading-l---GO18G","t-heading-xl":"src-components-FeaturesBlock----FeaturesBlock-module---t-heading-xl---QN2rI","t-anchors":"src-components-FeaturesBlock----FeaturesBlock-module---t-anchors---1ckYG","t-buttons":"src-components-FeaturesBlock----FeaturesBlock-module---t-buttons---tY25R","t-buttons-large":"src-components-FeaturesBlock----FeaturesBlock-module---t-buttons-large---17Ybl","t-formLabel":"src-components-FeaturesBlock----FeaturesBlock-module---t-formLabel---PrM7J","t-formHelper":"src-components-FeaturesBlock----FeaturesBlock-module---t-formHelper---ZZISM","t-formInput":"src-components-FeaturesBlock----FeaturesBlock-module---t-formInput---qQhra","t-tableHeading":"src-components-FeaturesBlock----FeaturesBlock-module---t-tableHeading---1pw0V","t-tableBody":"src-components-FeaturesBlock----FeaturesBlock-module---t-tableBody---2Eutu","t-opaque":"src-components-FeaturesBlock----FeaturesBlock-module---t-opaque---14FOr","t-bold":"src-components-FeaturesBlock----FeaturesBlock-module---t-bold---9uuNI","t-italic":"src-components-FeaturesBlock----FeaturesBlock-module---t-italic---3W5kd","featuresBlock":"src-components-FeaturesBlock----FeaturesBlock-module---featuresBlock---23OSq","category":"src-components-FeaturesBlock----FeaturesBlock-module---category---1TcVt","slideInBottomMild":"src-components-FeaturesBlock----FeaturesBlock-module---slideInBottomMild---2A_Ft","general":"src-components-FeaturesBlock----FeaturesBlock-module---general---1egiz","recreation":"src-components-FeaturesBlock----FeaturesBlock-module---recreation---34gu1","domestic":"src-components-FeaturesBlock----FeaturesBlock-module---domestic---2_m7m","facilities":"src-components-FeaturesBlock----FeaturesBlock-module---facilities---3jRyV","slideInTop":"src-components-FeaturesBlock----FeaturesBlock-module---slideInTop---2VfdQ","slideInTopMild":"src-components-FeaturesBlock----FeaturesBlock-module---slideInTopMild---2WO15","slideInBottom":"src-components-FeaturesBlock----FeaturesBlock-module---slideInBottom---1EqQ9","slideOutTop":"src-components-FeaturesBlock----FeaturesBlock-module---slideOutTop---11Lis","slideOutTopMild":"src-components-FeaturesBlock----FeaturesBlock-module---slideOutTopMild---2lAyS","slideOutBottom":"src-components-FeaturesBlock----FeaturesBlock-module---slideOutBottom----gcI9","slideOutBottomMild":"src-components-FeaturesBlock----FeaturesBlock-module---slideOutBottomMild---1tvSM","shake-horizontal":"src-components-FeaturesBlock----FeaturesBlock-module---shake-horizontal---37dcc"};

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FeaturesBlock = __webpack_require__(182);
	
	var _FeaturesBlock2 = _interopRequireDefault(_FeaturesBlock);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _FeaturesBlock2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocationMapModule = __webpack_require__(87);
	
	var _LocationMapModule2 = _interopRequireDefault(_LocationMapModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationMap = function LocationMap() {
	  return _react2.default.createElement(
	    'section',
	    { className: _LocationMapModule2.default.locationMap },
	    _react2.default.createElement('iframe', { src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2555.236419420243!2d6.581601615876036!3d50.1754158150249!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bfbf438f8f9275%3A0xbec49c56efc673ce!2sDorfstra%C3%9Fe+1%2C+54574+Kopp%2C+Germany!5e0!3m2!1sen!2sus!4v1509376536933', width: '800', height: '600', frameBorder: '0' })
	  );
	};
	
	exports.default = LocationMap;
	module.exports = exports['default'];

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-LocationMap----LocationMap-module---loader---w_lJJ","before":"src-components-LocationMap----LocationMap-module---before---XxFfL","after":"src-components-LocationMap----LocationMap-module---after---1KiQp","t-body":"src-components-LocationMap----LocationMap-module---t-body---2IEdo","t-small":"src-components-LocationMap----LocationMap-module---t-small---1yZ2t","t-heading-xs":"src-components-LocationMap----LocationMap-module---t-heading-xs---2Piam","t-heading-s":"src-components-LocationMap----LocationMap-module---t-heading-s---2Nane","t-heading-m":"src-components-LocationMap----LocationMap-module---t-heading-m---2nQrt","t-heading-l":"src-components-LocationMap----LocationMap-module---t-heading-l---19TJe","t-heading-xl":"src-components-LocationMap----LocationMap-module---t-heading-xl---2-3pQ","t-anchors":"src-components-LocationMap----LocationMap-module---t-anchors---r6Cq8","t-buttons":"src-components-LocationMap----LocationMap-module---t-buttons---3Eg55","t-buttons-large":"src-components-LocationMap----LocationMap-module---t-buttons-large---ztjeH","t-formLabel":"src-components-LocationMap----LocationMap-module---t-formLabel---2RprS","t-formHelper":"src-components-LocationMap----LocationMap-module---t-formHelper---13e9N","t-formInput":"src-components-LocationMap----LocationMap-module---t-formInput---1P7z-","t-tableHeading":"src-components-LocationMap----LocationMap-module---t-tableHeading---bRS21","t-tableBody":"src-components-LocationMap----LocationMap-module---t-tableBody---3xXEp","t-opaque":"src-components-LocationMap----LocationMap-module---t-opaque---3HVxR","t-bold":"src-components-LocationMap----LocationMap-module---t-bold---2segq","t-italic":"src-components-LocationMap----LocationMap-module---t-italic---1S-WN","locationMap":"src-components-LocationMap----LocationMap-module---locationMap---2Jx-l","slideInBottomMild":"src-components-LocationMap----LocationMap-module---slideInBottomMild---2gA4X","slideInTop":"src-components-LocationMap----LocationMap-module---slideInTop---1RBgs","slideInTopMild":"src-components-LocationMap----LocationMap-module---slideInTopMild---24tBC","slideInBottom":"src-components-LocationMap----LocationMap-module---slideInBottom---3lI22","slideOutTop":"src-components-LocationMap----LocationMap-module---slideOutTop---33xT6","slideOutTopMild":"src-components-LocationMap----LocationMap-module---slideOutTopMild---2fSmV","slideOutBottom":"src-components-LocationMap----LocationMap-module---slideOutBottom---2Xib-","slideOutBottomMild":"src-components-LocationMap----LocationMap-module---slideOutBottomMild---2LESn","shake-horizontal":"src-components-LocationMap----LocationMap-module---shake-horizontal---1oTTZ"};

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LocationMap = __webpack_require__(56);
	
	var _LocationMap2 = _interopRequireDefault(_LocationMap);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _LocationMap2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SliderModule = __webpack_require__(88);
	
	var _SliderModule2 = _interopRequireDefault(_SliderModule);
	
	var _timers = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var autoLoop = null;
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      (0, _timers.setTimeout)(function () {
	        _this.setState({ sliderWidth: _this.sliderElement.offsetWidth });
	      }, 500);
	
	      window.addEventListener('resize', _this._boundWidthListener);
	      _this._autoLoop('start');
	    };
	
	    _this.componentWillUnmount = function () {
	      window.removeEventListener('resize', _this._boundWidthListener);
	      _this._autoLoop('stop');
	    };
	
	    _this._widthListener = function () {
	      _this.setState({ sliderWidth: _this.sliderElement.offsetWidth });
	    };
	
	    _this._previousSlide = function () {
	      var currentImageIndex = _this.state.currentImageIndex;
	      var images = _this.props.images;
	
	
	      _this.setState({
	        currentImageIndex: currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1
	      });
	    };
	
	    _this._nextSlide = function () {
	      var currentImageIndex = _this.state.currentImageIndex;
	      var images = _this.props.images;
	
	
	      _this.setState({
	        currentImageIndex: currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1
	      });
	    };
	
	    _this._autoLoop = function (state) {
	      if (state === 'start') {
	        autoLoop = setInterval(function () {
	          _this._nextSlide();
	        }, 8000);
	      } else {
	        clearInterval(autoLoop);
	      }
	
	      return null;
	    };
	
	    _this._renderImages = function () {
	      return _this.props.images.map(function (image, index) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: index,
	            className: _SliderModule2.default.imageContainer,
	            style: { left: '-' + _this.state.currentImageIndex * _this.state.sliderWidth + 'px' }
	          },
	          _react2.default.createElement('img', { src: image.image, alt: image.alt, className: _SliderModule2.default.imageTag })
	        );
	      });
	    };
	
	    _this.state = {
	      currentImageIndex: 0,
	      sliderWidth: 0
	    };
	
	    _this._boundWidthListener = _this._widthListener.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _SliderModule2.default.slider,
	        ref: function ref(div) {
	          _this2.sliderElement = div;
	        },
	        onMouseEnter: function onMouseEnter() {
	          _this2._autoLoop('stop');
	        },
	        onMouseLeave: function onMouseLeave() {
	          _this2._autoLoop('start');
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _SliderModule2.default.controls },
	        _react2.default.createElement(
	          'button',
	          { className: _SliderModule2.default.controlLeft, onClick: function onClick() {
	              _this2._previousSlide();
	            } },
	          '\u2039'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: _SliderModule2.default.controlRight, onClick: function onClick() {
	              _this2._nextSlide();
	            } },
	          '\u203A'
	        )
	      ),
	      this._renderImages()
	    );
	  };
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    alt: _propTypes2.default.string.isRequired,
	    image: _propTypes2.default.string.isRequired
	  })).isRequired
	};
	exports.default = Slider;
	module.exports = exports['default'];

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-Slider----Slider-module---loader---36SEb","before":"src-components-Slider----Slider-module---before---2j73U","after":"src-components-Slider----Slider-module---after---3LoSw","t-body":"src-components-Slider----Slider-module---t-body---CGRje","t-small":"src-components-Slider----Slider-module---t-small---2hRiT","t-heading-xs":"src-components-Slider----Slider-module---t-heading-xs---3QkCq","t-heading-s":"src-components-Slider----Slider-module---t-heading-s---2lhX9","t-heading-m":"src-components-Slider----Slider-module---t-heading-m---3l-r_","t-heading-l":"src-components-Slider----Slider-module---t-heading-l---WD4ZX","t-heading-xl":"src-components-Slider----Slider-module---t-heading-xl---1bqxn","t-anchors":"src-components-Slider----Slider-module---t-anchors---1Mv-U","t-buttons":"src-components-Slider----Slider-module---t-buttons---3T0qX","t-buttons-large":"src-components-Slider----Slider-module---t-buttons-large---2Ne5i","t-formLabel":"src-components-Slider----Slider-module---t-formLabel---1T0kY","t-formHelper":"src-components-Slider----Slider-module---t-formHelper---16SWJ","t-formInput":"src-components-Slider----Slider-module---t-formInput---LZPvm","t-tableHeading":"src-components-Slider----Slider-module---t-tableHeading---2Cxmq","t-tableBody":"src-components-Slider----Slider-module---t-tableBody---3U-PS","t-opaque":"src-components-Slider----Slider-module---t-opaque---32n3Y","t-bold":"src-components-Slider----Slider-module---t-bold---3q8Q-","t-italic":"src-components-Slider----Slider-module---t-italic---1v0EE","slider":"src-components-Slider----Slider-module---slider---3yXx9","controlLeft":"src-components-Slider----Slider-module---controlLeft---3K_Jj","controlRight":"src-components-Slider----Slider-module---controlRight---wVtos","controls":"src-components-Slider----Slider-module---controls---xbtvv","imageContainer":"src-components-Slider----Slider-module---imageContainer---2QzF7","imageTag":"src-components-Slider----Slider-module---imageTag---3QwH6","slideInTop":"src-components-Slider----Slider-module---slideInTop---8gpSH","slideInTopMild":"src-components-Slider----Slider-module---slideInTopMild---3Crc3","slideInBottom":"src-components-Slider----Slider-module---slideInBottom---2UL1Q","slideInBottomMild":"src-components-Slider----Slider-module---slideInBottomMild---1pVie","slideOutTop":"src-components-Slider----Slider-module---slideOutTop---3G-i_","slideOutTopMild":"src-components-Slider----Slider-module---slideOutTopMild---3_vmq","slideOutBottom":"src-components-Slider----Slider-module---slideOutBottom---1VOki","slideOutBottomMild":"src-components-Slider----Slider-module---slideOutBottomMild---2S1AM","shake-horizontal":"src-components-Slider----Slider-module---shake-horizontal---226-5"};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Slider = __webpack_require__(58);
	
	var _Slider2 = _interopRequireDefault(_Slider);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Slider2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    title: "Het huis",
	    featuresTitle: "Kenmerken en faciliteiten",
	    featuresP1: "Het huis is erg praktisch ingericht. Zo zijn er 9 slaapkamers met op iedere slaapkamer een douche, wastafel en toilet. Twee van deze slaapkamers bevinden zich op de begane grond, en zijn geschikt voor minder-validen (geen drempels). Op de begane grond bevinden zich verder de gemeenschapsruimte, de keuken, extra toiletten en een droogruimte.",
	    featuresP2: "Op de eerste etage bevinden zich de overige 7 slaapkamers (waarvan 1 kamer is ingericht voor 4 personen en 1 kamer voor 6 personen). De tweede etage is multifunctioneel ingericht als speel -, oefen- of knutselruimte. Mocht het slecht weer zijn, er is een fraaie zolder waar allerlei activiteiten gedaan kunnen worden.Ook leuk voor een spelletjesavond.",
	    featuresSlider1Alt: "Slaapkamer",
	    featuresSlider2Alt: "Badkamer",
	    featuresSlider3Alt: "Recreatieruimte",
	    featuresSlider4Alt: "Hal",
	    featuresSlider5Alt: "Keuken",
	    featuresSlider6Alt: "Woonkamer",
	    featuresItems1Title: "Algemeen",
	    featuresItems1: ["Voldoende parkeerplaatsen", "Terras met veranda", "Grote tuin", "Internet en WiFi", "Geheel rookvrij"],
	    featuresItems2Title: "Recreatie",
	    featuresItems2: ["Tafeltennis", "Tafelvoetbal", "Airhockey", "Trampoline", "Bordspellen", "Recreatieruimte", "Wandelroutes", "Fietsroutes", "Mountainbikeroutes"],
	    featuresItems3Title: "Huishoudelijk",
	    featuresItems3: ["Vaatwasser", "Kookgelegenheid", "Magnetron", "Koelkast", "Koffiezetapparaat", "Exclusief beddengoed", "Exclusief handdoeken", "Exclusief theedoeken"],
	    featuresItems4Title: "Inrichting",
	    featuresItems4: ["Douche, toilet en wastafel per slaapkamer", "2 Slaapkamers begane grond", "7 Slaapkamers eerste etage", "Grote speelruimte tweede etage", "Kinderbed beschikbaar", "Kinderstoel", "Droogruimte", "Barbecue"],
	    historyTitle: "Geschiedenis",
	    historyP1: "Het huis “Ferienhaus Vulkaneifel Kopp” is in 1983-1984 gebouwd als pension. In 1989 werd het pension overgenomen door een wandelvereniging uit Köln. Sinds 1993 is het huis (onder de naam “Wanderheim Vulkaneifel”) in bezit geweest van de “Mährisch-Schlesischer-Sudetengebirgsverein”. Het huis was tegen een vergoeding toegankelijk voor alle leden (en eventuele gasten) van de MSSGV.",
	    historyP2: "Sinds 2016 is het huis in het bezit van Toine en Anja Spierings. Zij hebben het concept iets veranderd en het huis ingezet als groepswoning. Het huis kan dus sinds 2016 gehuurd worden door grotere groepen en grote families (tot 24 personen), maar is niet meer voor individuen toegankelijk.",
	    koppTitle: "Kopp",
	    koppP1: "Het plaatsje Kopp is met zijn ca. 200 inwoners een klein rustig dorpje dat is omgeven door romatische dalen in het hart van de Vulkaan-Eifel. De gemeente is ongeveer 840 hectare groot en kent een hoogte van 404 tot 559 meter.",
	    koppP2: "Kopp kent lokale clubs en ambachtelijke bedrijven. De plaats is idyllisch omgeven door loof- en naaldbossen, kent vele vakantiewoningen en een hotel. Op de vele goed bewegwijzerde wandelpaden is het niet ongewoon dat u tijdens het lopen wild tegenkomt.",
	    koppP3: "Bij Kopp hoort ook het gehucht Eigelbach, dat gelegen is in een drooggevallen kratermeer. Dit is zeer goed te zien als u van Gerolstein, via Hinterhausen naar Kopp rijdt. Eigelbach ligt iets ten noorden van Kopp."
	  },
	  de: {
	    title: "Das Haus",
	    featuresTitle: "Funktionen und Einrichtungen",
	    featuresP1: "Das Haus hat eine sehr praktische Dekoration. Es gibt 9 Schlafzimmer mit Dusche, Waschbecken und Toilette. Zwei dieser Schlafzimmer sind rollstuhlgerecht (keine erhöhten Türstufen). Es gibt auch ein Wohnzimmer, eine Küche, zusätzliche Toiletten und einen Trockenraum.",
	    featuresP2: "Auf der ersten Etage sind weitere 7 Schlafzimmer (ein Zimmer für 4 und ein Zimmer für 6 Personen). Der zweite Stock ist multifunktional und hat ein Spiel-, eine Übung- und ein Handwerkzimmer. Bei schlechtem Wetter gibt es einen schönen und großen Dachboden, wo alle Arten von Spielen gespielt werden können.",
	    featuresSlider1Alt: "Slafzimmer",
	    featuresSlider2Alt: "Badezimmer",
	    featuresSlider3Alt: "Aufenthalstraum",
	    featuresSlider4Alt: "Eingangshalle",
	    featuresSlider5Alt: "Küche",
	    featuresSlider6Alt: "Wohnzimmer",
	    featuresItems1Title: "Allgemein",
	    featuresItems1: ["Ausreichend Parkplätze", "Terrasse mit Veranda", "Großer Garten", "Internet und WLAN/WiFi", "Vollständig Nichtraucher"],
	    featuresItems2Title: "Erholung",
	    featuresItems2: ["Ping-Pong-Tisch", "Tischfußball", "Airhockeytisch", "Trampolin", "Brettspiele", "Aufenthalstraum", "Wanderwege", "Fahrradwege", "Mountainbike-Strecken"],
	    featuresItems3Title: "Haushalt",
	    featuresItems3: ["Geschirrspüler", "Kochmöglichkeiten", "Mikrowelle", "Kühlschrank", "Kaffeemaschine", "Ausgeschlossen: Bettwäsche", "Ausgeschlossen: Handtücher", "Ausgeschlossen: Küchentücher"],
	    featuresItems4Title: "Einrichtungen",
	    featuresItems4: ["Badezimmer mit Dusche, Toilette und Waschbecken pro Zimmer", "2 Schlafzimmer im Erdgeschoss", "7 Schlafzimmer im ersten Stock", "Großer Spielzimmer im zweiten Stock", "Kinderbett zur Verfüging", "Kinderstuhl verfügbar", "Trockenraum", "Barbecue"],
	    historyTitle: "Geschichte",
	    historyP1: "Das “Ferienhaus Vulkaneifel Kopp” wurde in 1983-1984 als Gasthaus gebaut. Im Jahr 1989 wurde das Gasthaus durch ein Wanderverein in Köln übernommen. Seit 1993 war das Haus (unter dem Namen “Wanderheim Vulkaneifel”) im Besitz der “Mährisch-Schlesischer-Sudetengebirgsverein”. Das Haus wurde für eine Gebühr offen für alle Mitglieder (und Ihren Gäste) des MSSGV.",
	    historyP2: "Seit 2016 ist das Haus im Besitz von Toine und Anja Spierings. Sie haben das Konzept ein wenig geändert und das Haus als Wohngruppe verwendet. Das Haus kann ab 2016 gemietet werden von größeren Gruppen und großen Familien (bis zu 24 Personen), aber es ist nicht mehr zugänglich für Einzelpersonen.",
	    koppTitle: "Kopp",
	    koppP1: "Die Stadt Kopp, ist ein kleines ruhiges Dorf mit rund 200 Einwohnern. Das Dorf ist umgeben von romantischen Tälern im Herzen des Vulkaneifels. Kopp ist etwa 840 Hektar groß und liegt auf eine Höhe von 404 bis 559 Metern.",
	    koppP2: "Kopp hat lokale Vereine und Handwerksbetriebe. Der Ort ist idyllisch, von Laub- und Nadelwäldern umgeben, hat viele Ferienhäuser und ein Hotel. Auf den vielen gut ausgeschilderten Wanderwegen, ist es nicht ungewöhnlich, dass Sie auf Wildtiere stoßen beim Spaziergang.",
	    koppP3: "Bei Kopp gehört auch den Weiler Eigelbach, die Sich in einem trockenen Kratersee befindet. Sehr gut zu sehen wenn Sie von Gerolstein über Hinterhausen nach Kopp fahren. Eigelbach liegt unmittelbar nördlich von Kopp."
	  },
	  en: {
	    title: "The house",
	    featuresTitle: "Features and facilities",
	    featuresP1: "The house has a very practical decoration. There are 9 bedrooms with each a shower, sink, and toilet. Two of these bedrooms are on the ground floor and are wheelchair accessible (no elevated doorsteps). There is also a living room, a kitchen, additional toilets and a drying room.",
	    featuresP2: "On the first floor are another 7 bedrooms (one room for 4, and one room for 6 people). The second floor is multifunctional and has as a play, an exercise and a craftroom. In case of bad weather, there is a beautiful and large attic where all kinds of games can be played.",
	    featuresSlider1Alt: "Bedroom",
	    featuresSlider2Alt: "Bathroom",
	    featuresSlider3Alt: "Recreation room",
	    featuresSlider4Alt: "Hallway",
	    featuresSlider5Alt: "Kitchen",
	    featuresSlider6Alt: "Living room",
	    featuresItems1Title: "General",
	    featuresItems1: ["Ample parking", "Terrace with veranda", "Large garden", "Internet and WiFi", "Non-smoking"],
	    featuresItems2Title: "Recreation",
	    featuresItems2: ["Ping-Pong table", "Foosball table", "Airhockey table", "Trampoline", "Board games", "Recreation room", "Hiking trail", "Bicycle trails", "Mountainbike trails"],
	    featuresItems3Title: "Domestic",
	    featuresItems3: ["Dishwasher", "Cooking facilities", "Microwave", "Refrigerator", "Coffeemaker", "Excluded: Bedding", "Excluded: Towels", "Excluded: Kitchen towels"],
	    featuresItems4Title: "Facilities",
	    featuresItems4: ["Bathroom with shower, toilet and sink per room", "2 Bedrooms on ground floor", "7 Bedrooms on first floor", "Large play area on second floor", "Cot available", "Children's chair available", "Drying room", "Barbecue"],
	    historyTitle: "History",
	    historyP1: 'The house "Ferienhaus Vulkaneifel Kopp" was built as a guest house in 1983-1984. In 1989 the guest house was taken over by a hiking club from Köln. The house had been in posession of the "Mährisch-Schlesischer-Sudetengebirgsverein" under the name "Wanderheim Vulkaneifel" (MSSGV) since 1993. The house was accessible to all members (and any guests) of the MSSGV for a fee.',
	    historyP2: "Since 2016 the house is owned by Toine and Anja Spierings. They have changed the concept slightly and have repurposed the house as a group home. The house can now be rented by larger groups and large families (up to 24 people), but is no longer accessible to individuals.",
	    koppTitle: "Kopp",
	    koppP1: "The town of Kopp, with its 200 inhabitants, is a small quiet village surrounded by romantic valleys in the heart of the Vulkaneifel. The municipality is about 840 hectares and has an altitude of 404 to 559 meters.",
	    koppP2: "Kopp has local clubs and craft companies. The place is idyllically surrounded by deciduous and coniferous forests, has many holiday homes and a hotel. On the many well-signposted hiking trails, encouters with wild animals are not uncommon.",
	    koppP3: "Kopp also belongs to the hamlet of Eigelbach, which is located in a dried-up crater lake. This is very noticable when you drive to Kopp from Gerolstein, via Hinterhausen. Eigelbach is located slightly to the north of Kopp."
	  }
	};
	
	exports.default = localization;
	module.exports = exports["default"];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ContentBlock = __webpack_require__(10);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _FeaturesBlock = __webpack_require__(183);
	
	var _FeaturesBlock2 = _interopRequireDefault(_FeaturesBlock);
	
	var _LocationMap = __webpack_require__(57);
	
	var _LocationMap2 = _interopRequireDefault(_LocationMap);
	
	var _Slider = __webpack_require__(59);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _thehouse = __webpack_require__(106);
	
	var _thehouse2 = _interopRequireDefault(_thehouse);
	
	var _featuresSlider = __webpack_require__(418);
	
	var _featuresSlider2 = _interopRequireDefault(_featuresSlider);
	
	var _featuresSlider3 = __webpack_require__(419);
	
	var _featuresSlider4 = _interopRequireDefault(_featuresSlider3);
	
	var _featuresSlider5 = __webpack_require__(420);
	
	var _featuresSlider6 = _interopRequireDefault(_featuresSlider5);
	
	var _featuresSlider7 = __webpack_require__(421);
	
	var _featuresSlider8 = _interopRequireDefault(_featuresSlider7);
	
	var _featuresSlider9 = __webpack_require__(422);
	
	var _featuresSlider10 = _interopRequireDefault(_featuresSlider9);
	
	var _featuresSlider11 = __webpack_require__(423);
	
	var _featuresSlider12 = _interopRequireDefault(_featuresSlider11);
	
	var _history = __webpack_require__(424);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _kopp = __webpack_require__(425);
	
	var _kopp2 = _interopRequireDefault(_kopp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TheHousePage = function TheHousePage(props) {
	  var language = props.language;
	
	
	  var sliderImages = [{ image: _featuresSlider2.default, alt: _thehouse2.default[language].featuresSlider1Alt }, { image: _featuresSlider4.default, alt: _thehouse2.default[language].featuresSlider2Alt }, { image: _featuresSlider6.default, alt: _thehouse2.default[language].featuresSlider3Alt }, { image: _featuresSlider8.default, alt: _thehouse2.default[language].featuresSlider4Alt }, { image: _featuresSlider10.default, alt: _thehouse2.default[language].featuresSlider5Alt }, { image: _featuresSlider12.default, alt: _thehouse2.default[language].featuresSlider6Alt }];
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { darkBackground: true },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-heading-xl' },
	        _thehouse2.default[language].title
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true, sliderRight: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _thehouse2.default[language].featuresTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _thehouse2.default[language].featuresP1
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _thehouse2.default[language].featuresP2
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Slider2.default, { images: sliderImages })
	      )
	    ),
	    _react2.default.createElement(_FeaturesBlock2.default, { language: language }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true, reverse: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _thehouse2.default[language].historyTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _thehouse2.default[language].historyP1
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _thehouse2.default[language].historyP2
	        )
	      ),
	      _react2.default.createElement('div', { style: { backgroundImage: 'url(' + _history2.default + ')' } })
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _thehouse2.default[language].koppTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _thehouse2.default[language].koppP1
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _thehouse2.default[language].koppP2
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _thehouse2.default[language].koppP3
	        )
	      ),
	      _react2.default.createElement('div', { style: { backgroundImage: 'url(' + _kopp2.default + ')' } })
	    ),
	    _react2.default.createElement(_LocationMap2.default, null)
	  );
	};
	
	TheHousePage.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	exports.default = TheHousePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-thehouse-js-96c9ca36d26f58705baf.js